/**
 * @module Core Web Vitals
 * @description Core Web Vitals Reporting
 */
const thresholds = {
  CLS: [0.1, 0.25],
  FCP: [1800, 3000],
  FID: [100, 300],
  LCP: [2500, 4000],
  TTFB: [100, 600],
};

/**
 * @function getRating
 * @description Get Core Web Vitals rating for each metric.
 * @see https://github.com/GoogleChromeLabs/web-vitals-report/blob/71b0879334798c732f460945ded5267cab5a36bf/src/js/analytics.js#L57-L65
 *
 * @param  {Number}  value
 * @param  {Array}   thresholds
 * @return {String}
 */
const getRating = (value, threshold) => {
  if (value > threshold[1]) return "POOR";
  if (value > threshold[0]) return "NI"; // NI == Needs Improvement
  return "GOOD";
};

/**
 * @function sendToAnalytics
 * @description Track web vitals data via Tagular.
 * @see https://github.com/GoogleChrome/web-vitals#readme
 * @see https://app.make.rvapps.io/schemas/sch_1ofhDFwJqLfXE91RzyPPIFhuyt6
 *
 * @param  {Object}  metric { name, value }
 * @return {void}
 */
const sendToAnalytics = (metric) => {
  const { name, value } = metric;

  cohesion("ready", () => {
    // Copy the webContext object and add web-vitals library info.
    const modifiedContext = { ..._Tagular.webContext };
    modifiedContext.library = {
      name: "web-vitals",
      version: "2.1.0",
    };

    // Beam the data to Make, weeee ⚡.
    tagular("beam", {
      "@type": "core.WebVitals.v1",
      metricName: String(name),
      rating: getRating(value, thresholds[name]),
      value: Number(value),
      webContext: modifiedContext,
    });
  });
};

export default sendToAnalytics;
